import * as effects from './effects';
import {
  generateItemFilters,
  generateFilterValues,
} from 'state/requestForQuote/transformer';
import asyncTreeRequester from 'utility/asyncTreeRequester';
import tree from 'state';
import { generateCriteriaQueryFilters } from 'state/requestForQuote/transformer_criteria';

var categoriesCursor = tree.select(['categories']);

export async function getCategoriesProducts({
  pagination,
  filters,
  sorting,
  keyword,
  criteria,
} = {}) {
  await asyncTreeRequester({
    func: effects.getCategories.bind(this, { keyword, criteria }),
    pagination,
    filters,
    sorting,
    cursor: categoriesCursor,
    path: ['c'],
  });
}

export async function setFilterCriteria(criteria) {
  categoriesCursor.set(
    ['categoriesItemFilter', 'activeFilters', 'criteria'],
    criteria
  );
}

export async function setActiveRfqItem(seed = {}) {
  categoriesCursor.set(
    ['categoriesItemFilter', 'rfqItemFilters'],
    generateItemFilters(null, seed, {
      range: { multiple: true },
    })
  );
  setFilterCriteria(generateCriteriaQueryFilters());
}

export async function onChangeCriteria(branch, type, data) {
  categoriesCursor.set(['categoriesItemFilter', 'rfqItemFilters', type], data);
  getCategoriesProducts({ criteria: prepareCriteria() });
}

export function prepareCriteria() {
  const filterData = generateFilterValues(
    categoriesCursor.get(['categoriesItemFilter', 'rfqItemFilters'])
  );
  return generateCriteriaQueryFilters(filterData);
}
